export default "__VITE_ASSET__04c01746__"